import { FiltroDeImportacao } from "@/models";
import { ImportacaoServiceAdapter } from "@/usecases/importacao/adapter";
import { AxiosRequestConfig } from "axios";
import { injectable } from "inversify-props";
import { find, findItens, findAllItens, baixarXmls, findCashbacksProcessadosByImportacaoId, findCashbacksProcessadosAgrupados, podeGerarDownloadCompleto, possuiImportacoesEmAbertoNoUsuarioLogado } from '@/api/importacoes'

@injectable()
export class ImportacaoService implements ImportacaoServiceAdapter {
	find = async (params?: FiltroDeImportacao, config?: AxiosRequestConfig) => await find(params, config)

	findItens = async (params?: any, config?: AxiosRequestConfig) => await findItens(params, config)

	findAllItens = async (params?: any, config?: AxiosRequestConfig) => await findAllItens(params, config)

	baixarXmls = async (idImportacao: string, config?: AxiosRequestConfig) => await baixarXmls(idImportacao, config)

	podeGerarDownloadCompleto = async (lojaId: string, config?: AxiosRequestConfig): Promise<any> =>  await podeGerarDownloadCompleto(lojaId, config);

	possuiImportacoesEmAbertoNoUsuarioLogado = async (usuarioId: string, config?: AxiosRequestConfig): Promise<any> =>  await possuiImportacoesEmAbertoNoUsuarioLogado(usuarioId, config);

	findCashbacksProcessadosByImportacaoId = async (idImportacao: string, config?: AxiosRequestConfig) => await findCashbacksProcessadosByImportacaoId(idImportacao, config)

	findCashbacksProcessadosAgrupados = async (idImportacao: string, incluirDobro: boolean, config?: AxiosRequestConfig) => await findCashbacksProcessadosAgrupados(idImportacao, incluirDobro, config)

}
